import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("page-heading")
export class PageHeading extends LitElement {
  @property() heading = "";
  @property() description = "";

  static styles = css`
    :host {
      display: block;
      margin-bottom: 18px;
    }

    .page-heading {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      gap: 20px;
    }

    .page-heading-copy {
      min-width: 0;
    }

    h1 {
      margin: 4px 0 5px;
      font-size: 27px;
      letter-spacing: 0;
    }

    p {
      margin: 0;
      color: #4d5664;
    }

    .heading-actions {
      display: flex;
      gap: 8px;
    }

    @media (max-width: 650px) {
      .page-heading {
        align-items: flex-start;
        flex-direction: column;
      }
    }
  `;

  render() {
    return html`
      <div class="page-heading">
        <div class="page-heading-copy">
          <h1>${this.heading}</h1>
          <p>${this.description}</p>
        </div>
        <div class="heading-actions"><slot></slot></div>
      </div>
    `;
  }
}
